// the operations-team expect us to substitute pN.* to ps.* when using https
export const sanitisePollHost = (pollHost: string) => pollHost.replace(/^(p\d+)/, 'ps')
